// src/lib/useEtroit.js — « est-on sur un écran étroit ? » (refonte mobile
// 2026-08-22). UN seul seuil pour tous les panneaux : 860 px, le même que la
// frise. Sous ce seuil, les menus flottants MONTENT DU BAS en pleine largeur
// (un popover ancré se fait rogner au bord d'un téléphone).
import { useState, useEffect } from 'react'

export default function useEtroit(seuil = 860) {
  const [etroit, setEtroit] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(`(max-width: ${seuil}px)`).matches : false)
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined
    const mq = window.matchMedia(`(max-width: ${seuil}px)`)
    const maj = () => setEtroit(mq.matches)
    mq.addEventListener('change', maj)
    return () => mq.removeEventListener('change', maj)
  }, [seuil])
  return etroit
}
